module.exports = __webpack_public_path__ + "static/img/SFG116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/SFG116.png
// module id = 514C
// module chunks = 0